import { PermissionsProtectedRoute } from 'client/routes/PermissionsProtectedRoute';
import React from 'react';
import { RouteObject } from 'react-router-dom';
import { dataFeedPermissions } from './permissions';

const DataFeedCreditPage = React.lazy(
  () => import('./components/DataFeedCreditPage')
);

export const dataFeedCreditRoutes: RouteObject = {
  path: dataFeedPermissions.path,
  element: (
    <PermissionsProtectedRoute
      pageId={dataFeedPermissions.pageId}
      currentPath="/data-feed-credit"
    />
  ),
  children: [
    {
      path: dataFeedPermissions.path,
      element: (
        <React.Suspense fallback={undefined}>
          <DataFeedCreditPage />
        </React.Suspense>
      ),
    },
  ],
};
